import { Component, OnInit } from '@angular/core';
import { Category } from 'projects/qcloud-models/category/category.model';
import { CategoryService } from 'projects/qcloud-rest-client/src/lib/category.service';
import { LocationService } from 'projects/qcloud-rest-client/src/lib/location.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Editor, toHTML } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { ReservationLimit } from 'projects/qcloud-models/reservation/reservation-limit';
import { ReservationModuleConfiguration } from 'projects/qcloud-models/reservation/reservation-module-configuration';
import { ReservationQuestion } from 'projects/qcloud-models/reservation/reservation-questions';
import { ReservationService } from 'projects/qcloud-rest-client/src/lib/reservation.service';
import { OnHoursService } from 'projects/qcloud-rest-client/src/lib/onHours.service';

@Component({
  selector: 'app-on-hours',
  templateUrl: './on-hours.component.html',
  styleUrls: ['./on-hours.component.css']
})
export class OnHoursComponent implements OnInit {

  editor: Editor;
  form: UntypedFormGroup;
  categories: Category[];
  onHoursCategories: Category[];
  initialCategories: Category[];
  public categoryMultiCtrl: UntypedFormControl;
  noSelectedCategories: string = 'no-reservation-categories';

  formSubmitted: boolean = false;
  reservationConfiguration: ReservationModuleConfiguration;
  questions: ReservationQuestion[];
  reservationLimits: ReservationLimit[];
  isSmsEnabled: boolean;

  constructor(private categoryService: CategoryService, private toastr: ToastrService,
    private translate: TranslateService, private reservationService: ReservationService,
    public locationService: LocationService,private onHoursService: OnHoursService) { }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  ngOnInit(): void {
    this.editor = new Editor();
    this.form = new UntypedFormGroup({
      editorContent: new UntypedFormControl("<p></p>")
    });

    if (!this.locationService.getLocationConstraints().isOnHoursEnabled) return;

    this.categoryService.getCategories(
      (data) => {
        this.categories = data;
        this.onHoursCategories = data.filter(x => x.canOnHour);
        this.initialCategories = new Array<Category>();
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].canOnHour) {
            this.initialCategories.push(this.categories[i]);
          }
        }
        this.categoryMultiCtrl = new UntypedFormControl(this.initialCategories);
      },
      () => { }
    );

    this.reservationService.getReservationConfiguration(data => {
      this.reservationConfiguration = data;
      this.form = new UntypedFormGroup({
        editorContent: new UntypedFormControl(data.terms)
      });
      this.checkSms();
    }, () => { });

    this.getReservationQuestionsAndLimits();
  }

  saveConfiguration() {
    this.formSubmitted = true;
    this.updateOnHoursCategories();
  }

  updateOnHoursCategories() {
    let ids = new Array<number>();
    this.categories.forEach(category => {
      if (this.categoryMultiCtrl.value.includes(category)) {
        category.canOnHour = true;
        ids.push(category.id);
      }
      else {
        category.canOnHour = false;
      }
    });
    this.onHoursService.updateOnHoursCategories(ids,
      () => {
        this.formSubmitted = false;
        this.translate.get('reservation-categories-save-success').subscribe((res: string) => {
          this.onHoursCategories = this.categories.filter(x => x.canOnHour == true);
          this.toastr.success(res);
        });
      },
      () => {
        this.formSubmitted = false;
        this.translate.get('reservation-categories-save-error').subscribe((error: string) => {
          this.translate.get('repeat').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

  updateReservationConfiguration() {
    let content = this.form.get("editorContent");
    if (content.value) {
      if (typeof content.valid === 'string') {
        this.reservationConfiguration.terms = toHTML(content.value);
      } else {
        this.reservationConfiguration.terms = content.value;
      }
    } else {
      this.reservationConfiguration.terms = "<p></p>";
    }
    this.reservationService.setReservationConfiguration(this.reservationConfiguration,
      () => {
        this.formSubmitted = false;
        this.translate.get('reservation-configuration-save-success').subscribe((res: string) => {
          this.onHoursCategories = this.categories.filter(x => x.canOnHour == true);
          this.toastr.success(res);
        });
      },
      () => {
        this.formSubmitted = false;
        this.translate.get('reservation-configuration-save-error').subscribe((error: string) => {
          this.translate.get('repeat').subscribe((res: string) => {
            this.toastr.error(res, error);
          });
        });
      }
    );
  }

  getReservationQuestionsAndLimits() {
    this.reservationService.getReservationQuestionaire(false, (data) => {
      this.questions = data;
    },
      () => { });

    this.reservationService.getReservationLimits().subscribe((res) => this.reservationLimits = res);
  }

  checkSms() {
    this.isSmsEnabled = this.locationService.getLocationConstraints().isSmsEnabled;
    if (!this.isSmsEnabled) {
      this.reservationConfiguration.sendReservationSms = false;
    }
  }

}
